<template>
        <v-sheet
            id="contact"
            color="#333333"
            dark
            tag="section"
            tile
        >
            <div class="py-12"></div>

                <v-container>
                <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Contact Us</h2>

                <v-responsive
                    class="mx-auto mb-12"
                    width="56"
                >
                    <v-divider class="mb-1"></v-divider>

                    <v-divider></v-divider>
                </v-responsive>

                <v-theme-provider v-if="!response" light>
                    <v-row class="mx-12">
                        <v-col cols="12">
                            <v-text-field
                            flat
                            label="Name*"
                            solo
                            v-model="name"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                            flat
                            label="Email*"
                            solo
                            v-model="email"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea
                            flat
                            label="Message*"
                            solo
                            v-model="message"
                            ></v-textarea>
                        </v-col>

                        <v-col
                            class="mx-auto"
                            cols="auto"
                        >
                            <v-btn
                            color="accent"
                            x-large
                            @click="sendContactDetails"
                            >
                            Submit
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-theme-provider>
                <v-theme-provider v-if="response" light>
                    <div align="center"><span>{{response}}</span></div>
                </v-theme-provider>
                </v-container>

            <div class="py-12"></div>
        </v-sheet>
</template>


<script>
    export default {
        name: 'ContactUs',

        data: () => ({
            name: '',
            email: '',
            message: '',
            response: ''
        }),
        methods: {
            sendContactDetails() {
                console.log("Submitting form");
                let formData = new FormData();
                formData.append('name', this.name);
                formData.append('email', this.email);
                formData.append('message', this.message);

                this.$http
                    .post(this.getHost() + 'contactus', formData)
                    .then(response => {
                        console.log(response);
                        if (response.status == 200) {
                            this.response = response.body['msg'];
                        }
                    }, error => {
                        console.log(error);
                        this.msg = error.body['msg']
                    });
            }
        }
    }
</script>
